import { system, LookupStorage } from "portalframework";
import * as ko from "knockout";
import * as entities from "entities";
import * as _ from "lodash";
import { personExtended, UserSearchCriteria, person_role, userIdentity, IUserPreferences } from "organized";
import { BaseService } from "./_common/_baseService";
import { portalHttpService } from "./_common/httpService";

class UserService extends BaseService {
  //
  constructor() {
    super("UserManagement");
  }

  public get CurrentUser() {
    return new userIdentity();
  }

  public getUsersListScreenData = async (): Promise<entities.SearchResult> => {
    let requiredLookups = ["C_PERSON_REGISTRATION_STATUS"];
    let lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    let data = ko.toJSON({ requiredLookups: lookupsToFetch });

    const result = await portalHttpService.post<any>(system.apiURL() + "api/UserManagement/UserListScreenData", data);

    _.each(lookupsToFetch, (lookupName) => {
      let list = result.result.results[lookupName];
      if (list) {
        LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
      }
    });
    let reqs;
    if (result.result.results && result.result.results.request) {
      reqs = entities.loadRelation(result.result.results.product, "product", "array")();
    }
    return new entities.SearchResult({ data: reqs, count: result.count });
  };

  public getUserSubPlaces = async (places: string[]): Promise<string[]> => {
    let url = `${this.baseApiUrl()}/GetUserSubPlaces`;
    if (places.length > 0) {
      url += `/${places.join(";")}`;
    }
    return await portalHttpService.get<any>(url);
  };

  public searchUsers = async (criteria: UserSearchCriteria): Promise<entities.SearchResult> => {
    const data = await portalHttpService.post<any>(
      system.apiURL() + "api/UserManagement/SearchUsers",
      ko.toJSON(criteria)
    );

    return new entities.SearchResult({
      data: entities.loadEntities(data.result.person, "person")(),
      count: data.count,
    });
  };

  public getUser = async (
    person_id = this.CurrentUser.personId
  ): Promise<{ user: personExtended; roles: KnockoutObservableArray<entities.user_role> }> => {
    let requiredLookups = ["C_PERSON_REGISTRATION_STATUS"];
    let lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    let data = ko.toJSON({ person_id: person_id, requiredLookups: lookupsToFetch });
    const result = await portalHttpService.post<any>(system.apiURL() + "api/UserManagement/GetUser", data);

    _.each(lookupsToFetch, (lookupName) => {
      let list = result.results[lookupName];
      if (list) {
        LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
      }
    });
    let person: personExtended = null;
    if (result.results && result.results.person) {
      person = new personExtended(result.results.person.person);
    }
    let user_roles: KnockoutObservableArray<entities.user_role>;
    if (result.results && result.results.user_role) {
      user_roles = entities.loadEntities(result.results.user_role, "user_role");
    }
    return { user: person, roles: user_roles };
  };

  public addrole = async (person_id: string, user_role: string): Promise<person_role> => {
    let data = ko.toJSON({ person_id: person_id, user_role: user_role });
    const result = await portalHttpService.post<any>(system.apiURL() + "api/UserManagement/addrole", data);
    return new person_role(result.person_role.person_role);
  };

  public removeRole = async (person_role: person_role): Promise<void> => {
    let data = ko.toJSON({ person_role: person_role });
    await portalHttpService.post<any>(system.apiURL() + "api/UserManagement/removeRole", data);
  };

  public getRoles = async (personId: string) => {
    return await portalHttpService.post<any>(
      system.apiURL() + "api/UserManagement/GetRoles",
      ko.toJSON({ person_id: personId })
    );
  };

  getUserPreferences = async () => {
    const data = await portalHttpService.get<IUserPreferences>(`${this.baseApiUrl()}/GetUserPreferences`);

    return data;
  };
  updateUserPreferences = async (preferences: any) => {
    await portalHttpService.post<void>(`${this.baseApiUrl()}/UpdateUserPreferences`, ko.toJSON(preferences));
  };
}
export const userService = new UserService();
